var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{attrs:{"id":"#app"}},[_c('iframe',{attrs:{"src":_vm.src1,"width":"100%","height":"800","frameborder":"0","scrolling":"auto","id":"iframename","name":"iframename"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }